var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isProd)?_c('div',{staticClass:"git-branch-display"},[_c('div',[_c('i',[_vm._v(_vm._s(_vm.env)+" ")]),_c('b',[_vm._v(_vm._s(_vm.gitBranch))]),_c('i',[_vm._v(" "+_vm._s(_vm.gitDate))]),_c('i',[_vm._v(" "+_vm._s(_vm.apiUrl))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }